var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7151 3.42859L4.28655 3.42859C3.33941 3.42859 2.57227 4.19573 2.57227 5.14287L2.57227 14.5714C2.57227 15.5186 3.33941 16.2857 4.28655 16.2857H8.57227L12.0008 20.5714L15.4294 16.2857H19.7151C20.6623 16.2857 21.4294 15.5186 21.4294 14.5714L21.4294 5.14287C21.4294 4.19573 20.6623 3.42859 19.7151 3.42859Z",
    stroke: "#DEE1E6",
    strokeWidth: 2.05714,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.71484 7.71429L16.2863 7.71429",
    stroke: "#DEE1E6",
    strokeWidth: 2.05714,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.71484 12L12.8577 12",
    stroke: "#DEE1E6",
    strokeWidth: 2.05714,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFChat);
export default __webpack_public_path__ + "static/media/f-chat.0515e64f1ac0c04631bed8f7b618fe72.svg";
export { ForwardRef as ReactComponent };